/* Users.tsx
	Une page affichant la gestion des utilisateurs
	Utilise le composant UsersCrudCard pour lister, ajouter, éditer et supprimer les utilisateurs
*/

// Import React
import React from 'react';

// Import FontAwesome
import { faUsers } from '@fortawesome/free-solid-svg-icons';

// Import Layout
import PageHeader from 'layout/PageHeader';

// Import Feature
import { UsersCrudCard } from 'features/users';

// Page Users
const Users: React.FC = () => (
	<div className="min-h-screen bg-gray-100 p-6">
		<PageHeader
			icon={faUsers}
			title="Utilisateurs"
			subtitle="Gérez les utilisateurs de votre application"
		/>
		<UsersCrudCard size="lg" hideReturn className="mt-6" />
	</div>
);

// Export the Users component
export default Users;
